<h1 class="text-3xl font-bold text-center text-gray-800 my-12 mx-12"
    style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">
    Fostering the Urban Food System Transformation through Innovative Living Labs Implementation.
</h1>
<div class="w-1/2 mt-8 flex bg-gradient-to-t from-headerfr to-headerto"
    style="border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%; transform: translateX(50%);">
    <div class="p-16 text-center justify-center items-center text-yellow-200">
        <h4 class="text-xl font-bold text-white text-center" style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);">
            Transformation Journeys
        </h4>
        <p class="text-md font-light text-white text-center mt-4" style="text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);">
            The core ambition of FUSILLI is to overcome barriers for developing and implementing integrated, systemic
            food policies that support the transition towards sustainable food systems in urban, peri-urban and nearby
            rural areas. To achieve this goal, FUSILLI puts 12 Living Labs in a knowledge sharing and learning network
            to address the challenges of the food system transformation: These trajectories are visualized in what we
            call ‘Transformation Journeys’ – the journeys of the FUSILLI Living Labs to transform food systems.
        </p>
    </div>
</div>
<div class="flex flex-col justify-center items-center mt-12">
    <iframe src="https://prezi.com/p/embed/bQLGBQvRXtsRHNSSWzxn?autoplay=1&mute=1&enablejsapi=1/" id="iframe_container"
        frameborder="0" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen="" allow="autoplay" height="720"
        width="1280">
    </iframe>
</div>